module.exports = __webpack_public_path__ + "img/login-demo.53e3caa7.svg";